import { useEffect, useState } from 'react';
import { IconAlert } from './icons.jsx';
import { t } from '../i18n/index.jsx';

/**
 * Thin fixed banner shown when the browser loses connectivity. Pairs with the
 * GET retry logic in the API client so the user understands why requests stall.
 */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== 'undefined' && !navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;
  return (
    <div className="offline-banner" role="alert">
      <IconAlert width={15} height={15} />
      {t('You’re offline — changes may not be saved until your connection returns.')}
    </div>
  );
}
